import fetcher from "../../common/axiosInstance";
import {
  GET_ORDER_DETAILS,
  CREATE_ORDER,
  REFERRAL_ORDER,
  UPDATEFIELDS,
  CREATE_ORDER_ERROR,
  RESET_CHECKOUT_FIELDS,
} from "../types";
import { qs } from "url-parse";
import { CRYPTO_JS_SECRET_KEY } from "@globalConfig";
import { unbxdAnalytics } from "./unbxdActions";

import CryptoJS from "crypto-js";
import { handleHasAccountEvent } from "@/utils/common";
import {dispatchButtonLoading} from "@hooks/useButtonLoading";
import {dispatchFullLoading} from "@hooks/useFullLoading";

export const checkoutOnloadPage =
  (
    formData,
    successCallBack = undefined,
    failCallBack = undefined,
    enableLoading = false,
    updateCity = false,
    includes = []
  ) =>
  async (dispatch) => {
    if (enableLoading) dispatchFullLoading(true);

    await dispatch(
      getOrderDetails(
        formData,
        successCallBack,
        failCallBack,
        false,
        updateCity,
        () => {},
        includes
      )
    );
    if (enableLoading) dispatchFullLoading(false);
  };

export const getOrderDetails =
  (
    formData,
    callBack = undefined,
    failCallBack,
    // @fixme @abdallah unused variable
    _____REMOVE_ME = true,
    updateCity = false,
    setLoading,
    includes = []
  ) =>
  async (dispatch) => {

    dispatchButtonLoading(true);

    const res = await fetcher().post(
      `/order/get-details?include=roadService,warranty,banks${
        includes.length > 0 ? "," + includes.join(",") : ""
      }`,
      formData
    ).finally(() => {
      dispatchButtonLoading(false);
    });

    if (setLoading) setLoading(false);

    if (
      res.data &&
      res.data.success &&
      res.data.data.post_id &&
      !Array.isArray(res.data.data)
    ) {
      if (updateCity) {
        dispatch({
          type: UPDATEFIELDS,
          payload: {
            key: "city_id",
            value: res.data.data.city_id,
          },
        });
      }
      dispatch({
        type: GET_ORDER_DETAILS,
        payload: res.data.data,
      });
      if (callBack) callBack(res.data.data);
    } else {
      if (failCallBack) failCallBack();
    }

  };

/**
 * Create checkout order
 * @param {*} formData
 * @returns
 */
export const createOrder =
  (formData, callBack = undefined) =>
  async (dispatch, getState) => {
      dispatchFullLoading(true);
    const res = await fetcher().post(`/order/create`, formData);

    if (res.data && res.data.success && res?.data?.code == 200) {
      dispatch({
        type: CREATE_ORDER,
        payload: res.data.data,
      });
      if (callBack) callBack(res.data.data);
    } else {
      dispatch({
        type: CREATE_ORDER_ERROR,
        payload: res.data.data,
      });
      if (callBack) callBack(res?.data?.data);
    }
    // }
      dispatchFullLoading(false);
  };
/**
 * Get referral code
 * @param {*} formData
 * @param {*} callBack
 * @returns
 */
export const referralOrder =
  (formData, callBack = undefined) =>
  async (dispatch) => {
    const res = await fetcher().post(`/order/referral-code-check`, formData);
    if (res?.data?.success) {
      dispatch({
        type: REFERRAL_ORDER,
        payload: res.data.data,
      });
      if (callBack) callBack(res.data.data);
    }
  };

/**
 * Pay orders using credit cards
 * @param {*} formData
 * @param {*} callBack
 * @returns
 */
export const payOrderCreditCards =
  (
    formData,
    successCallBack = undefined,
    failCallBack = undefined,
    navigate,
    unbxdData
  ) =>
  async (dispatch) => {
      dispatchFullLoading(true);
    const res = await fetcher().post(`/order/pay`, formData);

    if (res.data?.data?.reserved_status != 1 && res.data.data.post_url) {
        dispatchFullLoading(false);
      navigate(res.data.data.post_url);
      return;
    }

    if (res.data?.data?.redirectUrl) {
      window.location.href = res.data.data.redirectUrl;
        dispatchFullLoading(false);

      return;
    }
    if (res.data?.data?.status) {
      successCallBack(res.data?.data);
        dispatchFullLoading(false);

      unbxdAnalytics(unbxdData);

      return;
    }
    failCallBack();
      dispatchFullLoading(false);

  };
// Perform apple pay validation when apple pay button is pressed
export const performApplePayPayment =
  (
    orderId,
    successCallBack = undefined,
    failCallBack = undefined,
    arboon = 150,
    navigate
  ) =>
  async (dispatch) => {
    const session = new ApplePaySession(3, {
      currencyCode: "SAR",
      countryCode: "SA",
      //requiredShippingContactFields: ['name', 'email', 'phone'],
      // lineItems: items,
      total: {
        label: "order",
        amount: arboon,
      },
      supportedNetworks: ["visa", "masterCard", "amex", "discover", "mada"],
      merchantCapabilities: ["supports3DS", "supportsCredit", "supportsDebit"],
    });
    session.begin();
    session.onvalidatemerchant = async (event) => {
      let params = {
        url: event.validationURL,
      };
      let response = await fetcher().post(
        "/order/validate-apple",
        qs.stringify(params)
      );
      session.completeMerchantValidation(response.data.data);
    };
    session.onpaymentauthorized = async (event) => {
      let token = event.payment.token;
      let formData = new FormData();
      formData.append("cardType", "applepay");
      formData.append("orderid", orderId);
      formData.append("token", JSON.stringify(token.paymentData));
      const res = await fetcher().post(`/order/pay`, formData);

      if (res.data?.data?.reserved_status != 1 && res?.data?.data?.post_url) {
        navigate(res.data.data.post_url);
        return;
      }
      let status;
      if (
        (typeof res.data.data == "string" && res.data.data == "TRUE") ||
        res.data.data.status
      ) {
        status = ApplePaySession.STATUS_SUCCESS;
        if (successCallBack) successCallBack();
      } else {
        status = ApplePaySession.STATUS_FAILURE;
        if (failCallBack) failCallBack();
      }
      session.completePayment(status);
    };
    // session.oncancel = getOnCancel(resolve, reject, session);
  };




/**
 * Payment processing endpoint
 * @param {*} formData
 * @param {*} callBack
 * @returns
 */
export const processPayment =
  (formData, successCallBack = undefined, failCallBack = undefined, navigate) =>
  async (dispatch) => {
      dispatchFullLoading(true);
    const res = await fetcher().post(`/order/payment-proccessing`, formData);

    if (res.data?.data?.reserved_status != 1 && res.data.data.post_url) {
        dispatchFullLoading(false);
      navigate(res.data.data.post_url);
      return;
    }

    if (res.data.data == "TRUE" || res.data.data.status) {
      successCallBack(res.data.data);
    } else {
      failCallBack();
    }
      dispatchFullLoading(false);
  };

export const updateFields = (payload) => async (dispatch) => {
  dispatch({
    type: UPDATEFIELDS,
    payload: payload,
  });
};

export const resetCheckoutFields = (payload) => async (dispatch) => {
  dispatch({
    type: RESET_CHECKOUT_FIELDS,
    payload: payload,
  });
};
export const resetReferralData = (payload) => async (dispatch) => {
  dispatch({
    type: REFERRAL_ORDER,
    payload: null,
  });
};


// TODO: Remove this function @abdallah
export const loginAfterPay =
  ({ orderId, isFinance, cb,cb2, lang }) =>
  async (dispatch) => {
    const res = await fetcher().post(
      `/customer/auto-create-user`,
      qs.stringify({
        order_id: orderId,
        is_finance: isFinance,
        hashed: hash(orderId),
      })
    );

    if (res.data.data) {
        handleHasAccountEvent({
        hasAccount: res.data.data.has_account,
        status: "Success",
        phone_number: res.data.data?.phone_number,
        lang: lang,
        city_name: res.data.data?.city_name,
        user_name: res.data.data?.full_name,
        referral_location: +isFinance ? "finance_order" : "cash_order",
      });
      cb && cb(!res.data.data.has_account);
      cb2 & cb2(res.data.data);
//////////////////////////////////////////////

    }
  };

export const hash = (input) => {
  const hashedData = CryptoJS.SHA256(
    CRYPTO_JS_SECRET_KEY ? CRYPTO_JS_SECRET_KEY : "" + input
  );
  return hashedData.toString();
};

